import React, { useEffect, useRef, useState } from "react";
import "./Step4.css";
import ClinicMap from "../../Dashboard/ClinicMap";
import BookingDetailsNext from "../../Dashboard/BookingDetailsNext";
import cardIcon from '../../../Assets/card.png';
import appleIcon from '../../../Assets/appleIcon.png';
import gpayIcon from '../../../Assets/googleIcon.png';
import BookingConfirmation from "../../Dashboard/BookingConfirmation";
import CheckoutForm from "./card3D";
import axios from "axios";
import {  Button, Input, message } from "antd";
import { Config } from "../../Common/Config";
import CancelationBookingDetails from "../CancelationBookingDetails";
import { Select,DatePicker, Form,Grid} from 'antd';
import dayjs from 'dayjs';
import { ArrowLeftOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import GooglePayButton from './GooglePayButton';
import ApplePayButton from './ApplePayButton';
import { getNames } from "country-list";
import isPostalCode from 'validator/lib/isPostalCode';
import { postcodeValidatorExistsForCountry, postcodeValidator } from 'postcode-validator';
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import StripePaymentForm from "./StripePaymentForm";
// Initialize Stripe with your public key
const { Option } = Select;
 const countriesName = getNames().sort();
  countriesName[0]="United Kingdom (UK)";
// const propsss = 

// const Step4 = ({onBack = propsss.onBack, onContinue = propsss.onContinue, bookingDetails= propsss.bookingDetails}) => {
const Step4 = ({onBack, onContinue, bookingDetails,showAppoinmentData}) => {
  // console.log("Step4",bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.corporateData?.requires_employee_number)
  const [apiLogs, setApiLogs] = useState([]);
  const [clientSecret, setClientSecret] = useState(null);
  const [showClientSecret, setShowClientSecret] = useState(false);
  const [clientSecretKey, setClientSecretKey] = useState(null);
  // console.log("porpsStep4", {onBack, onContinue, bookingDetails})
  const [paymentPublicKey, setPaymentPublicKey] = useState(null);
  // const [stripePromise, setStripePromise] = useState(null);
  const [publicKey,setPublicKey]=useState(null)
  const [postalCodeheck, setPostalCodecheck] = useState("");
  const [selectedCountry, setSelectedCountry] = useState('United Kingdom (UK)'); // default
  const [countryName, setCountryName] = useState("India");
  
  const [cardErrors, setCardErrors] = useState({
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        postalCode: '',
        cardholderName: ''
      });
    const specialPostcodes = ['ASCN 1ZZ', 'STHL 1ZZ', 'TDCU 1ZZ', 'BBND 1ZZ', 'BIQQ 1ZZ', 'FIQQ 1ZZ', 'GX11 1AA', 'PCRN 1ZZ', 'SIQQ 1ZZ', 'TKCA 1ZZ'];

  useEffect(() => {
    async function fetchPaymentKey() {
      try {
        // Use GET with query param for is_livemode=1
        const response = await fetch(`${Config.urlOpen}payment-keys`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const data = await response.json();
        // console.log("fetchPaymentKey data", data);
        // If API returns an array, extract the first public_key
        let key = null;
        if (Array.isArray(data.data) && data.data.length > 0) {
          key = data.data[0].public_key;
        } 
        if (key) {
          setPaymentPublicKey(key);
          // setStripePromise(loadStripe(key));
          setPublicKey(key);
        }
      } catch (err) {
        setPaymentPublicKey(null);
        // setStripePromise(null);
      }
    }
    fetchPaymentKey();
  }, []);
  const stripePromise = publicKey ?  loadStripe(publicKey) : null ;

  const stripePaymentRef = useRef();
  const googlePayRef = useRef();
  const applePayRef = useRef();
  const [BookedAppointmentPayload, setBookedAppointmentPayload ]= useState([]);
  const [phone, setPhone] = useState('');
  const [phoneTouched, setPhoneTouched] = useState(false);
  const [payment_intent_id,setPayment_intent_id] = useState(null)

  const [step, setStep] = useState(1);
  const [selected, setSelected] = useState('card');
   const [reason, setReason] = useState('Select appointment reason');
  const [comments, setComments] = useState('');
  const [agreeTnC, setAgreeTnC] = useState(false);
  const [agreeMarketing, setAgreeMarketing] = useState(false);
  const [count,setcount]=useState(true)
  const [showAppoinmentDataDisplay, setshowAppoinmentDataDisplay] = useState(undefined)
  const [loaderCalender, setloaderCalender] = useState(false)
  const [mobileNumberError, setMobileNumberError] = useState('');
  const [drpoDownData,setDropdown]=useState([])
  const [cardholderDifferent, setCardholderDifferent] = useState(false);
  const [cardholderName, setCardholderName] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [monthYear, setMonthYear] = useState('');
  const [loading, setLoading] = useState()
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [hide ,setHide]=useState(true)
  const [phoneOptionOpen,setPhoneOptionOpen]=useState(true)
  const hasReschedulingCharges = bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 ? true : bookingDetails?.oldData?.encryptBookingDetails?.rescheduling_charge_details?.amount > 0 ||bookingDetails?.oldDataExist == undefined ;
  const RescheduleAmmount  =  bookingDetails?.oldData?.encryptBookingDetails?.rescheduling_charge_details?.amount; 
  const BookingAmmount = bookingDetails.showAppoinmentData.price; 
  const pre_payment_enabled = bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 ? bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productData?.pre_payment_enabled : true
  const [ClientSecretLoading , setClientSecretLoading ] = useState();
  // console.log("pre_payment_enabled",{pre_payment_enabled,hasReschedulingCharges})


  const [clickCount, setClickCount] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [showLogs, setShowLogs] = useState(false);
  const [paymentIntentResponseCatchPayload, setPaymentIntentResponseCatchPayload] = useState(false);



  const handlePaymentDetailsClick = () => {
    const now = Date.now();
    // Reset count if more than 1 second has passed since last click
    if (now - lastClickTime > 1000) {
      setClickCount(1);
    } else {
      setClickCount(prev => prev + 1);
    }
    setLastClickTime(now);

    // Toggle logs if count reaches 6
    if (clickCount + 1 >= 6) {
      const willShow = !showLogs;
      setShowLogs(willShow);
      setClickCount(0);
      
      messageApi.open({
        type: 'info',
        content: willShow ? 'Developer logs enabled 👨‍💻' : 'Developer logs disabled',
        duration: 2,
        style: {
          marginTop: '20vh', // Position it higher up
        },
      });
    }
  };


  const isDevMode = false; 
  const defaultFormData = {
    firstName: 'Shital',
    lastName: 'k',
    gender: 'female',
    dob: '12-12-2001',
    email: 'shital@webdezign.co.uk',
    mobile: '1234567890',
    countryCode: '+44',
  };
    const [formInfo, setFormInfo] = useState(isDevMode ? defaultFormData : {
    firstName: '',
    lastName: '',
    gender: '',
    dob: '',
    email: '',
    mobile: '',
    countryCode: '+44',
    address1: '',
    address2: "",
    member_number: "",
    city: ''
  });
  
// Add this state at the top of your component
const [formErrors, setFormErrors] = useState({
  firstName: '',
  lastName: '',
  gender: '',
  dob: '',
  email: '',
  mobile: '',
  reason: '',
  agreeTnC: '',
});

// Add this function to log messages
const addLog = (message, type = 'info') => {
  setApiLogs(prev => [
    ...prev,
    {
      timestamp: new Date().toISOString(),
      message,
      type
    }
  ]);
};



  const { useBreakpoint } = Grid;
    const screens = useBreakpoint();

// Add this validation function
const validateForm = () => {
  // console.log("checking form validation", formSubmitted)
  let isValid = true;
  const newErrors = {
    firstName: '',
    lastName: '',
    gender: '',
    dob: '',
    email: '',
    mobile: '',
    reason: '',
    agreeTnC: '',
  };
  //  if (!formSubmitted) return true;

  // First Name validation
  if (!formInfo?.firstName.trim()) {
    newErrors.firstName = 'First name is required';
    isValid = false;
  }

  // Last Name validation
  if (!formInfo?.lastName.trim()) {
    newErrors.lastName = 'Last name is required';
    isValid = false;
  }

  // Gender validation
  if (!formInfo?.gender) {
    newErrors.gender = 'Gender is required';
    isValid = false;
  }

  // Date of Birth validation
  if (!formInfo.dob) {
    newErrors.dob = 'Date of birth is required';
    isValid = false;
  }

  // Email validation
  if (!formInfo?.email?.trim()) {
    newErrors.email = 'Email is required';
    isValid = false;
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formInfo?.email)) {
    newErrors.email = 'Please enter a valid email';
    isValid = false;
  }
  // react international phone validation
    // Mobile validation
  if (!formInfo?.mobile.trim()) {
    newErrors.mobile = 'Mobile number is required';
    isValid = false;
  } else {
    // Enhanced phone validation
    const phoneDigits = formInfo?.mobile.replace(/\D/g, '');
    if (phoneDigits.length < 8) {
      newErrors.mobile = 'Please enter a valid phone number';
      isValid = false;
    }
  }


  // Terms and Conditions validation
  if (!agreeTnC) {
    newErrors.agreeTnC = 'You must agree to the Terms & Conditions';
    isValid = false;
  }

  setFormErrors(newErrors);
  return isValid;
};

  const validatePhoneNumber = (phone) => {
    if (!phone) return false;
    
    // Remove all non-digit characters
    const digitsOnly = phone.replace(/\D/g, '');
    
    // Basic validation - at least 8 digits (country code + number)
    return digitsOnly.length >= 8;
  };
  // console.log("hasReschedulingCharges",{ hasReschedulingCharges, RescheduleAmmount, BookingAmmount})

  useEffect(() => {
    window.scrollTo(0, 0);
    async function dropdownApiCall() {
      try {
        const responce=await axios.get(`${Config.urlOpen}gp-appointment-reasons`);
          setDropdown(responce.data.data)
      } catch (error) {
        message.error({ type: 'error', content: error?.message });
      }
    }
    dropdownApiCall()
  },[])

  useEffect(() => {
    if (bookingDetails?.oldData?.encryptBookingDetails) {
      // console.log("bookingDetails-encryptBookingDetails comming to step4",bookingDetails?.oldData)
      const patientData = bookingDetails?.oldData?.encryptBookingDetails;
      setFormInfo({
        firstName: patientData?.patient_name?.split(' ')[0] || '',
        lastName: patientData?.patient_name?.split(' ')?.slice(1)?.join(' ') || '',
        gender: patientData?.patient_gender || '',
        // dob: patientData?.date_of_birth || '',
        // dob : "11-07-2018", 
        dob: patientData?.date_of_birth 
        ? dayjs(patientData.date_of_birth, "YYYY-MM-DD").format("DD-MM-YYYY")
        : '',
        email: patientData?.patient_email || '',
        mobile: patientData?.patient_phone || '',
        countryCode: patientData?.patient_country_code || ''
      });

    if (bookingDetails?.oldData?.encryptBookingDetails?.appointment_reason_id) {
      const appointmentReasonId = Number(bookingDetails.oldData.encryptBookingDetails.appointment_reason_id) || null;
      // console.log("appointmentReasonId", appointmentReasonId)
      setReason(appointmentReasonId);
    }
    if (bookingDetails?.oldData?.encryptBookingDetails?.notes) {
      const appointmentNotes = bookingDetails.oldData.encryptBookingDetails.notes|| "";
      // console.log("appointmentReasonId", appointmentNotes)
      setComments(appointmentNotes);
    }
    }
  }, [bookingDetails?.oldData?.encryptBookingDetails]);

  

  let tempData = {
  product: 'General GP consultation',
  // dummyProps,
  data: [
    {
      key: 'Duration',
      data: '15 minutes'
    },
    {
      key: 'languageData',
      data: 'Arabic'
    },
    {
      key: 'Gender',
      data: 'Male'
    },
  ],
  date: '14 January, 2025',
  time: '10:30',
  name: "Oxford Street",
  address: "6 Newburgh Street, Carnaby, London, W1F 7RQ",
}
const [cardNumber, setCardNumber] = useState('');

  const handleCardInput = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
    value = value.substring(0, 16); // Limit to 12 digits

    // Add space after every 4 digits
    const formatted = value.replace(/(.{4})/g, '$1 ').trim();

    setCardNumber(formatted);
  }
   const [expiry, setExpiry] = useState('');

  const handleExpiryChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    if (value.length > 6) value = value.substring(0, 6); // Max 6 digits (MMYYYY)

    // Auto-format to MM/YYYY
    if (value.length > 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }

    setExpiry(value);
  };
      const [cvc, setCvc] = useState('');

      const handleCvcChange = (e) => {
        let value = e.target.value.replace(/\D/g, ''); // Only numbers
        value = value.substring(0, 4); // Max 4 digits
        setCvc(value);
      };
        const handleCountryChange = (value) => {
      setSelectedCountry(value);
      handleInputChange({
        target: { name: "country", value },
      });
      setCountryName(value)
      // Clear postal code error when country changes
      setCardErrors(prev => ({
        ...prev,
        // postalCode: ''
        postalCode: validatePostalCode(postalCode, value)
      }));
    };

         const validatePostalCode = (code, country) => {
              // const ukPostcodeRegex = /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;
              const ukPostcodeRegex = /^([A-Z]{1,2}[0-9][0-9A-Z]? ?[0-9][A-Z]{2})$/i;
          if (!code) return 'Postal code is required';
          
          const trimmedCode = code.trim().toUpperCase();
          countries.registerLocale(enLocale);
    
          const trimmedName =country||selectedCountry?.trim();
          const clean = trimmedName?.replace(/\s*\(.*?\)\s*/g, "")?.trim();
          const countryCode = countries?.getAlpha2Code(clean, "en");
          
          if (postalCodeheck ==undefined || countryCode==undefined) {
            return
          }
    
            countries.registerLocale(enLocale);
            // const countryCode = countries?.getAlpha2Code("India", "en");
             if (!postcodeValidatorExistsForCountry(countryCode)) {
              return null; // or skip validation
            }
            const result = postcodeValidator(code, countryCode);
              // setIsValid(result);
              if (result === false) {
                setCardErrors({
                  ...cardErrors,
                  postalCode: `Please enter a valid ${country}  postal code`,
                })
                return `Please enter a valid ${country}  postal code`;
              }
          
          // Special handling for UK special postcodes
          if (country === 'UK' && specialPostcodes.includes(trimmedCode)) {
            return '';
          }
          
          // Validate based on country
          switch(country) {
            case 'UK':
              if (!isPostalCode(trimmedCode, 'GB') || !ukPostcodeRegex.test(trimmedCode)) {
                return `Please enter a valid ${country} postal code`;
              }
              break;
              
            case 'US':
              if (!isPostalCode(trimmedCode, 'US')) {
                return `Please enter a valid ${country} postal code`;
              }
              break;
              
            case 'CA':
              if (!isPostalCode(trimmedCode, 'CA')) {
                return `Please enter a valid ${country} postal code`;
              }
              break;
              
            default:
              // For other countries, just check if it's not empty
              if (!trimmedCode) {
                return 'Postal code is required';
              }
          }
          
          return '';
        };

 const hideConfirm = () => {
        setshowAppoinmentDataDisplay(null)
    }
  const twoFactAuth = async (paymentIntent) => {
    setLoading(true)
    // console.log("twoFactAuth called", paymentIntent)
    // return
    let payload = {
      payment_intent_id: paymentIntent.id,
    }
    const response = await axios.post(`${Config.urlOpen}check-stripe-payment`, payload);

    // console.log("check-stripe-payment response", response)
    if (response) {
      setcount(false);
      setLoading(false)
      setShowClientSecret(false)
    }


  }
    const twoFactAuthFail =  (message) => {
      messageApi.error(message || 'Payment failed. Please try again.');
      setLoading(false)
      setClientSecretKey(null)
      setShowClientSecret(false)
    }

  const options = [
    { id: 'card', label: 'Credit/ debit card', icon: cardIcon },
    { id: 'apple', label: 'Apple Pay', icon: appleIcon },
    // { id: 'gpay', label: 'Google Pay', icon: gpayIcon },
    { id: 'gpay', label: 'Google Pay', icon: gpayIcon },
  ];

  const [formData, setFormData] = useState({
    paymentMethod: "card"
  });

  const handleContinue = () => {
    setStep(2);
  };



  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ 
      ...formData, 
      [name]: type === 'checkbox' ? checked : value 
    });
  };
    const handleLoadError = (error) => {
      console.log("Error loading payment SDK:", error, typeof(error));
      messageApi.error(error.message || 'Error loading payment SDK');
    };


  const handleChange = (e) => {
    const { id, value } = e?.target || {};
    setFormInfo(prev => ({
      ...prev,
      [id]: value,
    }));





    // Clear error when user starts typing
    if (formErrors[id]) {
      setFormErrors(prev => ({
        ...prev,
        [id]: '',
      }));
    }


    // Special handling for date of birth
  if (id === 'dob') {
    const formattedDate = formatDateString(value);
    setFormInfo(prev => ({
      ...prev,
      [id]: formattedDate,
    }));
    
    // Clear error when user starts typing
    if (formErrors[id]) {
      setFormErrors(prev => ({
        ...prev,
        [id]: '',
      }));
    }
    return;
  }

      // Real-time email validation
  if (id === 'email') {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && !emailRegex.test(value)) {
      setFormErrors(prev => ({
        ...prev,
        email: 'Please enter a valid email',
      }));
    } else {
      setFormErrors(prev => ({
        ...prev,
        email: '',
      }));
    }
  }
    
 // Special handling for phone input
  if (id === 'mobile') {
    setPhone(value);
    setFormInfo(prev => ({
      ...prev,
      mobile: value,
    }));
    
    // Real-time validation feedback
    if (value && !validatePhoneNumber(value)) {
      setFormErrors(prev => ({
        ...prev,
        mobile: 'Please enter a valid phone number',
      }));
    } else {
      setFormErrors(prev => ({
        ...prev,
        mobile: '',
      }));
    }
    return;
  }
    
  };

  const minDate = dayjs('1921-01-01');

const disabledDate = (current) => {
    // Disable dates before 1921-01-01
    // return current && current.isBefore(minDate, 'day');
    return current && (current.isBefore(minDate, 'day') || current.isAfter(dayjs(), 'day'));
  };

    function convertDateFormat(input) {

  
  // Fix the malformed date string by adding spaces where needed
  const fixedInput = input
    .replace(/([a-zA-Z]{3})(\d{4})/, '$1 $2')  // Add space between month and year (Jul2025 -> Jul 2025)
    .replace(/(\d{2})(\d{2}:\d{2})/, '$1 $2'); // Add space between day and time (2411:30 -> 24 11:30)
  
  // Parse the properly formatted date string
  const date = new Date(fixedInput);
  
  if (isNaN(date.getTime())) {
    
    return 'Invalid date format';
  }

  // Format to YYYY-MM-DD HH:mm
  const pad = n => n.toString().padStart(2, '0');
  const formattedDate = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  
  
  return formattedDate;
}

// Example usage:
convertDateFormat("Thu, 24 Jul202511:30"); // Returns "2025-07-24 11:30"



function addTime(startTime = "10:30", durationInMinutes) {
  if (typeof startTime !== "string" || !startTime.includes(":")) {
    return null;
  }

  const [hoursStr, minutesStr] = startTime.split(":");
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  if (isNaN(hours) || isNaN(minutes)) {
    return null;
  }

  let durationNum = Number(durationInMinutes);
  if (durationNum<5) {
    durationNum=durationNum*15
    
  }
  else{
  if (isNaN(durationNum)) {
    const parts = String(durationInMinutes).trim().split(" ");
    durationNum = Number(parts[0]); // First word should be a number like "15"
  }

  if (isNaN(durationNum)) {
    return null;
  }
}
  const totalMinutes = hours * 60 + minutes + durationNum;
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;

  const formatted =
    String(newHours).padStart(2, "0") + ":" + String(newMinutes).padStart(2, "0");


  const response = convertDateFormat(bookingDetails?.date + " " + formatted); // Added space

  return response;
}


function duration() {
  const start = bookingDetails?.callbackData?.info?.start_time || "11:15"; // "16:15"
const end = bookingDetails?.callbackData?.info?.end_time || "11:45";     // "16:30"

  const today = new Date().toISOString().split("T")[0]; // e.g., "2025-06-24"
  const startDate = new Date(`${today}T${start}`);
  const endDate = new Date(`${today}T${end}`);

  const diffMs = endDate - startDate; // Difference in milliseconds
  const diffMins = diffMs / 60000;    // Convert to minutes

return diffMins
}
  const hasOldData = !!bookingDetails?.oldData;
  const dummyProps = {
    oldData:bookingDetails?.oldData,
    showAppoinmentData:
    // bookingDetails.showAppoinmentData
     {
      duration:bookingDetails?.showAppoinmentData.duration || "1",
      // language: { value: "en" },
      language:  bookingDetails?.showAppoinmentData?.selectedLanguage?.label || "English"     ,
      gender: bookingDetails?.showAppoinmentData.gender || "male",
      price :bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 ? ((bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productData?.pre_payment_enabled) ? `£  ${bookingDetails?.showAppoinmentData?.price }`: '') :`£  ${bookingDetails?.showAppoinmentData?.price }` || `£ ${bookingDetails?.callbackData?.info?.price}` ,
      type: "BookingForm",
      slot: {
        date: bookingDetails?.date,
        info: {
          start_time:bookingDetails?.showAppoinmentData?.time || bookingDetails?.time,

        },
        clinicData: {
          id: bookingDetails?.callbackData?.clinicData?.id || 1,
          name:bookingDetails?.callbackData?.clinicData?.name|| "Kings Cross",
          address: bookingDetails?.callbackData?.clinicData?.address  || "Suite 3-7, 344-354 Gray's Inn Road, London, WC1X 8BP",
          latitude: bookingDetails?.callbackData?.clinicData?.latitude || 51.5308 ,
          longitude: bookingDetails?.callbackData?.clinicData?.longitude || -0.1238 ,
        },
      },

      clinic: hasOldData
      ? { ...(bookingDetails?.showAppoinmentData?.clinic) }
      : {

          productCategory: {
          title: bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.title || bookingDetails?.oldData?.encryptBookingDetails?.product_category_name || "GP appointment",
          product_category_id: 
           bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id || 
           1,
        },
        non_gp_product_id: 
         bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_id || 
         null,
        },


    }
    ,

    // data:
    // // bookingDetails.data,
    //  {
    //   durationObjectById: {
    //     "duration-id-15": {
    //       duration: 15,
    //     },
    //   },
    //   languageData: [
    //     { value: "en", label: "English" },
    //     { value: "ar", label: "Arabic" },
    //     { value: "es", label: "Spanish" },
    //   ],
    // },

    data :{
      ...(bookingDetails.showAppoinmentData.data),
            languageData: [
        { value: "en", label: "English" },
        { value: "ar", label: "Arabic" },
        { value: "es", label: "Spanish" },
      ],
    },

    getAllHealthScreenData: {
      getAllHealthScreenData: {
        data: [
          { id: 1, name: "Full Health Check", non_gp_product_id: 100 },
          { id: 2, name: "Blood Screening", non_gp_product_id: 101 },
        ],
      },
    },

    callBackForbackpage: (type) => {
      // console.log("Back to:", type);
      onBack()
    },

    callback: (data, step) => {
      // console.log("Next step:", step, "with data:", data);
      handleContinue()
    },

    hide: hide,
  };

  // Add this function to get payment intent for gpay
const fetchPaymentIntent = async () => {
  try {
    setClientSecretLoading(true)
    const response = await axios.post(`${Config.urlOpen}stripe/payment-intent`, {
      amount: Math.round((RescheduleAmmount || BookingAmmount) * 100),
      currency: 'gbp'
    });
    
    if (response.data.clientSecret) {
      setClientSecret(response.data.clientSecret);
      setPayment_intent_id(response.data?.intent?.id)
      addLog(`Payment intent created successfully ${response.data.clientSecret}`, 'success');
    } else {
      throw new Error('No client secret received');
    }
  } catch (error) {
    addLog(`Failed to create payment intent: ${error.message}`, 'error');
    messageApi.error('Failed to initialize payment');
  } finally{
    setClientSecretLoading(false)
  }
};

useEffect(() => {
  if(selected === "gpay" || selected === "apple"){
    fetchPaymentIntent();
  }
}, [selected])




  // function convertDateToSQLFormat(dateStr) {
  //   const [day, month, year] = dateStr.split('/');
  //   return `${year}-${month}-${day}`;
  // }

  function convertDateToSQLFormat(dateStr) {
    if (!dateStr) return null; // Handle empty case
    
    // First check if it's already in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr;
    }
    
    // Handle both DD/MM/YYYY and DD-MM-YYYY formats
    const separator = dateStr.includes('/') ? '/' : '-';
    const parts = dateStr.split(separator);
    
    if (parts.length === 3) {
      // Ensure day and month are 2 digits
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      
      return `${year}-${month}-${day}`;
    }
    
    // Fallback for unexpected formats
    return null;
  }

//   // From form (with / separator)
// convertDateToSQLFormat("01/07/2025") // returns "2025-07-01"

// // From initial data (with - separator)
// convertDateToSQLFormat("01-07-2025") // returns "2025-07-01"

// // Already in SQL format
// convertDateToSQLFormat("2025-07-01") // returns "2025-07-01"


function formatEndTimeForHealth(bookingDetails) {
  if (!bookingDetails?.callbackData?.date || !bookingDetails?.callbackData?.info?.end_time) {
    return "2025-06-29 12:15"; // Default fallback value
  }

  try {
    // Parse the date (e.g., "Thu, 03 Jul") - dayjs can handle this format
    const dateStr = bookingDetails.callbackData.date;
    const timeStr = bookingDetails.callbackData.info.end_time;
    
    // Create dayjs object (will use current year if not specified)
    const dateObj = dayjs(dateStr + ' ' + timeStr, 'ddd, DD MMM HH:mm');
    
    // Format as YYYY-MM-DD HH:mm
    return dateObj.format('YYYY-MM-DD HH:mm');
  } catch (error) {
    return "2025-06-29 12:15"; // Fallback value
  }
}

 const productCategoryId =
  bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic
    ?.productCategory?.product_category_id;

   const callApi=
   {
    "status": 1,
    "clinic_id": bookingDetails?.callbackData?.clinicData?.id || 35,
    "preferred_gender": bookingDetails?.showAppoinmentData?.gender || "no_preference",
    "appointment_type_int": 1,
    "cardholder_name":cardholderName,
    "postal_code":postalCode,

    ...(bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1 && {     "languages": [
      bookingDetails?.showAppoinmentData?.language?.toString()
    ]} ) ,
    "notes": comments || "No comments",
     "start_time": convertDateFormat( bookingDetails?.date +bookingDetails?.time) || "2025-06-29 11:15",
     // different for health journey and gp booking
    "end_time":  (bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1  ? addTime(bookingDetails?.time,bookingDetails?.showAppoinmentData?.duration)  || "2025-06-29 12:15" :formatEndTimeForHealth(bookingDetails)),
    "product_category_id": bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id || bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id  || null,
    "override_spacers": 0,
    // "product_id" : null, 
    "product_id":Number(bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_id) || null, 
    "duration_id" : bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1  ?  bookingDetails?.showAppoinmentData?.duration :  null,
    "charges":  RescheduleAmmount || bookingDetails?.callbackData?.info?.price  ,
    "patient": {
        "first_name": formInfo?.firstName ,
        "last_name":formInfo?.lastName,
        "email": formInfo?.email,
        // "mobile_number":  formInfo.mobile,
        country_code: formInfo?.countryCode , 
        mobile_number: formInfo?.mobile,
        "date_of_birth":  convertDateToSQLFormat(formInfo?.dob) ,
        "gender": formInfo?.gender,
        "appointment_reason": "16",
        ...(productCategoryId == 3 && {
              address_1: formInfo?.address1,
              address_2: formInfo?.address2,
              city: formInfo?.city,
              member_number: formInfo?.member_number,
              }),
        // "override_spacers": 0,
        ...(bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1 && { "appointment_reason":reason?.toString()|| '0' }),        
    },
    // "rescheduling_charge": 0,
    
}



 

  const ca = { time :bookingDetails?.time, duration :  bookingDetails?.oldData?.duration}
  // return
const payload={
    "status": 1,
    "clinic_id": bookingDetails?.callbackData?.clinicData?.id ,
    "preferred_gender": bookingDetails?.encryptBookingDetails?.language_name ,
    "appointment_type_int": 1,
    "cardholder_name":cardholderName,
    "postal_code":postalCode,
    "languages": [
        "1"
    ],
    "notes": comments || "No comments",
    "start_time": convertDateFormat( bookingDetails?.date +bookingDetails?.time),
    // for gp there is duration 
    "end_time": addTime(bookingDetails?.time, bookingDetails?.oldData?.duration ) ,
    "product_category_id": bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id  || bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id,
    "override_spacers": 0,
    "duration_id": 1,
    "charges": RescheduleAmmount ||  Number(bookingDetails?.showAppoinmentData?.price) ,
    "patient": {
         "first_name": formInfo?.firstName,
          "last_name": formInfo?.lastName,
          "email":formInfo?.email,
          // "mobile_number": formInfo.mobile,
          country_code: formInfo?.countryCode , 
          mobile_number: formInfo?.mobile,
          "date_of_birth":convertDateToSQLFormat(formInfo?.dob) ,
          "gender":formInfo?.gender,
          ...(productCategoryId == 3 && {
              address_1: formInfo?.address1,
              address_2: formInfo?.address2,
              city: formInfo?.city,
              member_number: formInfo?.member_number,
  }),
//  ...(bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1 && { "appointment_reason":Number(reason) }),      
 ...(bookingDetails?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1 && { "appointment_reason":reason?.toString()|| '0' }),      

}
}


  async function apiCall() {
    // if (!postalCode) {
    //   setPostalCodeError("Postal Code is required");
    //   return message.error({ type: 'error', content: 'Postal Code is required' });
    // }
    setLoading(true)
    if (bookingDetails?.oldDataExist) {
      try {
        setLoading(true)
        const response = await axios.put(`${Config.urlOpen}appointments/reschedule/${bookingDetails?.appointMentId}`, payload);
        if (response.data.success) {
          // console.log("response", response)
          setBookedAppointmentPayload(response?.data);
          setcount(false); // This will show the BookingConfirmation component
          messageApi.success({ type: 'success', content: response?.data?.message });
        } else {
          messageApi.error({ type: 'error', content: response?.data?.message });
        }
        return response.data;
      } catch (error) {
        messageApi.error({ type: 'error', content: error?.message });
      }finally{
        setLoading(false)
      }
      
    } else {
      try {
        setLoading(true)
        const response = await axios.post(`${Config.urlOpen}appointments/book`, callApi);
        // setBookedAppointmentPayload(response?.data);
        if (response.data.success) {
          setBookedAppointmentPayload(response?.data);
          setcount(false); // This will show the BookingConfirmation component
          messageApi.success({ type: 'success', content: response?.data?.message });
        } else {
          messageApi.error({ type: 'error', content: response?.data?.message });
        }
        return response.data;
      } catch (error) {
        console.log(error)
        messageApi.error({ type: 'error', content: error?.response?.data?.message });
      }finally{
        setLoading(false)
      }
    }
  }



  const handlePaymentSuccess = async (paymentMethodId) => {
    // console.log("handlePaymentSuccess", paymentMethodId)
    try {
      setLoading(true);
      addLog(`Starting payment process with method: ${paymentMethodId}`, 'info');
      // Determine if we need to process payment
      const isReschedule = bookingDetails?.oldDataExist;
      const reschedulingCharge = bookingDetails?.oldData?.encryptBookingDetails?.rescheduling_charge_details?.amount || 0;
      const shouldProcessPayment = !isReschedule || (isReschedule && reschedulingCharge > 0);

      addLog(`Booking type: ${isReschedule ? 'Reschedule' : 'New booking'}`, 'info');
      addLog(`Payment required: ${shouldProcessPayment ? 'Yes' : 'No'}`, 'info');
      // Step 1: Book or Reschedule Appointment

      const bookingEndpoint = isReschedule 
      ? `${Config.urlOpen}appointments/reschedule/${bookingDetails?.appointMentId}`
      : `${Config.urlOpen}appointments/book`;

      const bookingPayload = isReschedule 
      ? { ...payload, ...(shouldProcessPayment && { payment_method: paymentMethodId }) }
      : { ...callApi, ...(shouldProcessPayment && { payment_method: paymentMethodId }) };
      
      const bookingResponse = isReschedule
        ? await axios.put(`${Config.urlOpen}appointments/reschedule/${bookingDetails?.appointMentId}`, {
            ...payload,
            ...(shouldProcessPayment && { payment_method: paymentMethodId })
          })
        : await axios.post(`${Config.urlOpen}appointments/book`, {
            ...callApi,
            ...(shouldProcessPayment && { payment_method: paymentMethodId })
          });


        addLog(`Calling booking API: ${bookingEndpoint}`, 'info');
        addLog(`Payload: ${JSON.stringify(bookingPayload, null, 2)}`, 'debug');
        addLog(`Booking API response: ${JSON.stringify(bookingResponse.data, null, 2)}`, 'info');
        // console.log("bookingResponse", bookingResponse)
  
      // Step 2: If booking was successful and payment is needed, call payment API
      if (bookingResponse.data.success) {
        setBookedAppointmentPayload(bookingResponse?.data);
        // console.log("bookingResponse", bookingResponse)
          localStorage.setItem("requires_auth", bookingResponse?.data?.google_calendar?.requires_auth);
        const appointmentId = bookingResponse.data.data.appointment_id;
        
        if (shouldProcessPayment) {

          if (selected === 'gpay' || selected === 'apple') {
           let response =  await confirmAppointmentAfterTwoFactAuth(appointmentId)
           if(response){
            setcount(false);
            setLoading(false)
           }else{
            setLoading(false)
            messageApi.error('Payment verification failed. Please try again.');
           }
            // Digital wallet payments are already processed - just verify success
            // addLog(`${selected.toUpperCase()} payment already processed`, 'success');
              
          } else {
            // Calculate amount based on scenario
            let amountInPence;
            if (isReschedule) {
              // For rescheduling, use the rescheduling charge amount
              amountInPence = Math.round(reschedulingCharge );
            } else {
              // For new appointment, use the regular price
              const priceInPounds = Number(bookingDetails?.showAppoinmentData?.price) || 0;
              amountInPence = Math.round(priceInPounds );
            }
    
            // Only proceed with payment if amount > 0
            if (amountInPence > 0) {

              addLog(`Processing payment of ${amountInPence} pence`, 'info');

              const paymentIntentResponse = await axios.post(`${Config.urlOpen}create-payment-stripe`, {
                appointment_id: appointmentId,
                type: isReschedule ? 'reschedule' : 'appointment',
                payment_method: paymentMethodId,
                amount: amountInPence,
                currency: 'gbp'
              });
              setPaymentIntentResponseCatchPayload(paymentIntentResponse?.data);
              console.log("paymentIntentResponse", paymentIntentResponse)

              if(paymentIntentResponse.data.message === "requires_action"){
                const clientSecret = paymentIntentResponse.data.data.client_secret;
                setClientSecretKey(clientSecret);
                setShowClientSecret(true)
                
                return
              }
             

             if (paymentIntentResponse.data.error) {
                addLog(`Stripe error: ${paymentIntentResponse.data.error.message}`, 'error');
                messageApi.error(paymentIntentResponse.data.error.message);
                setLoading(false);
                return; // Stop further processing
              }

              if (paymentIntentResponse.data.message == "succeeded") {
                setcount(false);
              }
              // Check payment response
              if (paymentIntentResponse.data.message !== "succeeded") {
                throw new Error("Payment processing failed");
              }
              addLog(`${isReschedule ? "Reschedule" : "Booking"} successful!`, 'success');
            }

          }
        }
        // setBookedAppointmentPayload(bookingResponse?.data);
  
        messageApi.success({ 
          type: 'success', 
          content: isReschedule ? "Appointment rescheduled successfully" : "Appointment booked successfully"
        });
        // setcount(false);
      } else {
        addLog(`Booking failed: ${bookingResponse?.data?.message}`, 'error');
        messageApi.error({ type: 'error', content: bookingResponse?.data?.message });
      }
  
    } catch (error) {
      const errorMsg = error?.response?.data?.message || error.message || "An error occurred";
      addLog(`Error: ${errorMsg}`, 'error');
      messageApi.error({ 
        type: 'error', 
        content: error?.response?.data?.message || error.message || "An error occurred"
      });
    } finally {
      setLoading(false);
    }
  };
 const confirmAppointmentAfterTwoFactAuth=(appointmentId)=>{
        // console.log('confirmAppointmentAfterTwoFactAuth :::', paymentIntent)
        let payload = {
            payment_intent_id: payment_intent_id,
            appointment_id :appointmentId

        }
        return new Promise(async (resolve, reject) => {
            try {
            const response = await axios.post(`${Config.urlOpen}check-stripe-payment`, payload);
            if(response.data && response.data.success){
                resolve(true)
            }else{
                resolve(false)
            }
        } catch (error) {
            resolve(false)
            console.log('try catch error  in confirmAppointmentAfterTwoFactAuth ', error)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || 'Something Went wrong',
            })
        }

        })
    }

  function checking() {
    if (formInfo.mobile.length ==0 || formInfo.firstName.length == 0 || formInfo.lastName.length == 0 || formInfo.email.length == 0,formInfo.dob.length == 0) {
                  return  messageApi.error({ type: 'error', content: 'All fields are required' })
    }else{
      return
    }
  }



  const formatDateString = (input) => {
  // Remove all non-digit and non-slash characters
  let cleaned = input.replace(/[^\d/]/g, '');
  
  // Auto-format as user types (DD/MM/YYYY)
  if (cleaned.length > 2 && !cleaned.includes('/')) {
    cleaned = cleaned.slice(0, 2) + '/' + cleaned.slice(2);
  }
  if (cleaned.length > 5 && cleaned.match(/\//g)?.length === 1) {
    cleaned = cleaned.slice(0, 5) + '/' + cleaned.slice(5);
  }
  
  // Limit to DD/MM/YYYY format
  if (cleaned.length > 10) {
    cleaned = cleaned.slice(0, 10);
  }
  
  return cleaned;
};
const paymentButtonChange=(id)=>{
  if(id === "gpay" || id === "apple"){
    setLoading(true)
  }else{
    setLoading(false)
  }
  setSelected(id)
}


const isValidDate = (dateString) => {
  if (!dateString) return false;
  
  // Test format DD/MM/YYYY
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return false;
  
  const parts = dateString.split('/');
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);
  
  // Check the ranges
  if (year < 1900 || year > new Date().getFullYear()) return false;
  if (month < 1 || month > 12) return false;
  
  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  
  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }
  
  return day > 0 && day <= monthLength[month - 1];
};


// const optionsHideLink = {
//   clientSecret: process.env.REACT_APP_PAYMENT_PUBLIC_KEY,
//   appearance: {
//     theme: 'stripe',
//   },
//   // 👇 disables the Link autofill option
//   disableLink: true
// };
  return (
    <>
    {count?
    <>
    <div className="step4-container" >
            {contextHolder}
      <section className="booking-summary">
        {bookingDetails?.oldDataExist?"": <h3  style={{background:"rgba(0, 131, 133, 0.25)" , color:"rgba(0, 131, 133)", padding:"8px ",fontWeight:"400",fontSize:"20px",marginTop:screens.md? "50px":"0px",             maxWidth:"605px", 
            marginInline: "auto",}} className="booking-title">My booking:</h3>}
       

      </section>
      {/* step 4  */}
      {bookingDetails?.oldDataExist?<CancelationBookingDetails {...dummyProps} />:<BookingDetailsNext {...dummyProps}  />}
      

      

      {step === 2 && (<>
      <form autoComplete="off" >


        <div className="booking-form" onSubmit={(e) => e.preventDefault()} > 
          <div className="form-section patient-details" style={{padding:"0px", ...(!hasReschedulingCharges && {
      maxWidth: "425px",
      marginInline: "auto"
    })}}>
            <h4 style={{   background:"#bfe0e0" , color:"rgba(0, 131, 133)", padding:"8px ",fontWeight:"400",fontSize:"20px",marginLeft: 'auto',marginRight: 'auto',  maxWidth:'605px'}} className="textLeft">Patient details:</h4>
            <div style={{maxWidth:screens.md? "393px":"100%",margin:"auto"}}>
            <div className="form-row">


<div className="form-container">
  <div className="user-form">
    
     <div className="form-field">


    <Form.Item name="first_name" 
    validateStatus={formErrors.firstName ? 'error' : ''} 
    help={formErrors.firstName}

    >
    <Input 
      type="text" 
      id="firstName" 
      className="custom_error_input boxShadowFix"
      placeholder=" " 
      required 
      value={formInfo?.firstName} 
      onChange={handleChange}  
      style={{borderRadius:"0px"}}   
      autoComplete='first_namenew'
    />
    <label htmlFor="firstName" className="labelTexl">First name</label>
  </Form.Item>
</div>

<div className="form-field">
  {/* <Input type="text" id="lastName" placeholder=" " required value={formInfo.lastName} onChange={handleChange} style={{borderRadius:"0px"}}  autoComplete='last_namenew'/>
  <label htmlFor="lastName" className="labelTexl">Last name</label> */}

  
    <Form.Item name="last_name" 
    validateStatus={formErrors.lastName ? 'error' : ''} 
    help={formErrors.lastName}
  //   style={{
  //   borderWidth:" 0px 0px 2px 0px",
  //   marginBottom: formErrors.lastName ? '0px' : '0', // Add space for error message
  // }}
    >
       <Input 
        type="text" 
        id="lastName" 
        placeholder=" " 
        required 
        className="boxShadowFix"
        value={formInfo?.lastName} 
        onChange={handleChange} 
        style={{borderRadius:"0px"}}  
        autoComplete='last_namenew'
       />
       <label htmlFor="lastName" className="labelTexl">Last name</label>

    </Form.Item>
</div>


<div className="" style={{ display: "flex",gap:20 }}>
  {/* Gender Field */}
  <div className="form-group">
    <label htmlFor="gender" style={{textAlign:"left"}}>Gender</label>
     <Form.Item validateStatus={formErrors.gender ? 'error' : ''} help={formErrors.gender}>
    <Select
      id="gender"
      name="gender"
      placeholder=""
      bordered={false}
      className="genderPaddingFix"
      value={formInfo?.gender} 
      style={{ borderBottom: '2px solid #666', padding: '4px 0', width: '100%',textAlign:"left" }}
      onChange={(value) =>
    handleChange({
      target: {
        name: 'gender',
        id: 'gender',
        value: value,
      },
    })
  }
    >
      <Option value="male">Male</Option>
      <Option value="female">Female</Option>
    </Select>
    </Form.Item>
  </div>

  {/* Date of Birth Field */}
  <div className="form-group" style={{marginBottom:"15px"}}>
    <label htmlFor="dob" style={{textAlign:"left"}}>Date of Birth</label>


<div   className="paddingBoottomFix">
    <Form.Item 
  validateStatus={formErrors.dob ? 'error' : ''} 
  help={formErrors.dob}

  style={{ marginBottom: formErrors.dob ? '24px' : '0' }}
>
  <DatePicker
    format="DD/MM/YYYY"
    disabledDate={disabledDate}
    style={{ 
      width: '100%',
      border: formErrors.dob ? '1px solid #ff4d4f !important' : '1px solid #444 !important',
      borderBottom: formErrors.dob ? '1px solid #ff4d4f !important' : '1px solid #444 !important',
      borderRadius: "0px",
      paddingLeft: "20px",
      //zoom fix 
      fontSize: "16px !important",
      transform: "scale(1) !important",
      transformOrigin: "left center !important"
    }}
    id="dob"
    value={formInfo.dob ? dayjs(formInfo?.dob, 'DD/MM/YYYY') : null}
    onChange={(date, dateString) => {
      // Format the date string
      const formattedDate = formatDateString(dateString);
      
      handleChange({
        target: {
          id: 'dob',
          name: 'dob',
          value: formattedDate,
        }
      });
      
      // Validate the date
      if (!isValidDate(formattedDate)) {
        setFormErrors(prev => ({
          ...prev,
          dob: 'Please enter a valid date in DD/MM/YYYY format',
        }));
      } else {
        setFormErrors(prev => ({
          ...prev,
          dob: '',
        }));
      }
    }}
    onBlur={(e) => {
      // When field loses focus, format it properly
      if (formInfo?.dob) {
        const parts = formInfo?.dob.split('/');
        const day = parts[0]?.padStart(2, '0') || '';
        const month = parts[1]?.padStart(2, '0') || '';
        const year = parts[2] || '';
        
        const formattedDate = `${day}${day?'/':''}${month}${month&&year?'/':''}${year}`;
        
        if (formattedDate !== formInfo?.dob) {
          setFormInfo(prev => ({
            ...prev,
            dob: formattedDate,
          }));
        }
      }
    }}
    className="no-placeholder dobFix doBPaddingFix"
    placeholder="DD/MM/YYYY"
    inputRender={(props) => (
      <input
        {...props}
        style={{
        fontSize: "16px", // Ensure minimum 16px font size
        // Optional: visually reduce size if needed
        transform: "scale(0.9375)", // 15px visual size (16 * 0.9375)
        transformOrigin: "left center"
      }}
        onKeyDown={(e) => {
          // Only allow numbers and slash
          if (!/[0-9/]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
            e.preventDefault();
          }
        }}
        onChange={(e) => {
          // Format as user types
          const formatted = formatDateString(e.target.value);
          if (formatted !== e.target.value) {
            e.target.value = formatted;
          }
          props.onChange(e);
        }}
      />
    )}
  />
</Form.Item>
</div>
</div>
</div>

<div className="form-field">


    <Form.Item name="email" validateStatus={formErrors.email ? 'error' : ''} help={formErrors.email}>
      <Input 
        type="email" 
        id="email" 
        placeholder=" " 
        // autoComplete='emailnew' 
        className="boxShadowFix"
        autoComplete="email"
        required value={formInfo?.email} 
        style={{borderRadius:"0px"}} 
        onChange={handleChange} 
        onBlur={e => {
          if (e.target.value !== formInfo.email) {
            setFormInfo(prev => ({ ...prev, email: e.target.value }));
          }
        }}
      />
      <label htmlFor="email" className="labelTexl">Email address</label>
    </Form.Item>
</div>



<div className="form-field">
                                <Form.Item
                                  name="mobile"
                                  validateStatus={
                                    formErrors.mobile ? "error" : ""
                                  }
                                  help={formErrors.mobile}
                                >
                                  <PhoneInput
                                    country="gb"
                                    preferredCountries={["gb"]}
                                    countryCodeEditable={false}
                                    showFlag={false}
                                    enableSearch
                                    value={
                                      formInfo?.countryCode?.replace("+", "") +
                                      formInfo?.mobile
                                    }
                                    onChange={(value, countryData) => {
                                      const countryCode = `+${countryData.dialCode}`;
                                      let nationalNumber = value.replace(
                                        countryData.dialCode,
                                        ""
                                      );

                                      if (nationalNumber.startsWith("0")) {
                                        nationalNumber = nationalNumber.replace(
                                          /^0+/,
                                          ""
                                        );
                                      }

                                      setFormInfo((prev) => ({
                                        ...prev,
                                        countryCode,
                                        mobile: nationalNumber,
                                      }));

                                      setPhoneTouched(true);

                                      if (formErrors.mobile) {
                                        setFormErrors((prev) => ({
                                          ...prev,
                                          mobile: "",
                                        }));
                                      }
                                    }}
                                    isOpen={phoneOptionOpen}
                                    onDropdownToggle={(isOpen) =>
                                      setPhoneOptionOpen(isOpen)
                                    }
                                    containerClass="phone-input-container"
                                    containerStyle={{
                                      width: "100%",
                                      borderBottom: formErrors.mobile
                                        ? "2px solid #ff4d4f"
                                        : "2px solid #666",
                                    }}
                                    inputStyle={{
                                      border: "none",
                                      background: "transparent",
                                      borderRadius: 0,
                                      boxShadow: "none",
                                      paddingLeft: "10px",
                                      width: "100%",
                                      height: "32px",
                                    }}
                                    buttonStyle={{
                                      background: "transparent",
                                      border: "none",
                                      left: 0,
                                      padding: "0 5px 0 0",
                                    }}
                                    dropdownStyle={{
                                      maxHeight: "170px",
                                      overflowY: "scroll",
                                    }}
                                    onBlur={() => setPhoneTouched(true)}
                                    placeholder="Mobile number"
                                  />
                                </Form.Item>
                              </div>

                            {bookingDetails?.showAppoinmentData
                                ?.showAppoinmentData?.clinic?.productCategory
                                ?.product_category_id == 3 && (
                                <>
                                {bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.corporateData?.requires_employee_number &&(
                                <div className="form-field">
                                    <Form.Item
                                      name="member_number"
                                      validateStatus={
                                        formErrors.member_number ? "error" : ""
                                      }
                                      help={formErrors.member_number}
                                      rules={[
                                        {
                                          required: bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.corporateData?.requires_employee_number,
                                          message: "Employee number is required",
                                        },
                                      ]}
                                    >
                                      <Input
                                        type="text"
                                        id="member_number"
                                        placeholder=" "
                                        // autoComplete='emailnew'
                                        className="boxShadowFix"
                                        autoComplete="member_number"
                                        required
                                        value={formInfo?.member_number}
                                        style={{ borderRadius: "0px" }}
                                        onChange={handleChange}
                                        onBlur={(e) => {
                                          if (
                                            e.target.value !== formInfo.member_number
                                          ) {
                                            setFormInfo((prev) => ({
                                              ...prev,
                                              member_number: e.target.value,
                                            }));
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor="member_number"
                                        className="labelTexl"
                                      >
                                        Employee number
                                      </label>
                                    </Form.Item>
                                  </div>
                                  )}
                                  <div className="form-field">
                                    <Form.Item
                                      name="address1"
                                      validateStatus={
                                        formErrors.address1 ? "error" : ""
                                      }
                                      help={formErrors.address1}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Address 1 is required",
                                        },
                                      ]}
                                    >
                                      <Input
                                        type="text"
                                        id="address1"
                                        placeholder=" "
                                        // autoComplete='emailnew'
                                        className="boxShadowFix"
                                        autoComplete="address1"
                                        required
                                        value={formInfo?.address1}
                                        style={{ borderRadius: "0px" }}
                                        onChange={handleChange}
                                        onBlur={(e) => {
                                          if (
                                            e.target.value !== formInfo.address1
                                          ) {
                                            setFormInfo((prev) => ({
                                              ...prev,
                                              address1: e.target.value,
                                            }));
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor="address1"
                                        className="labelTexl"
                                      >
                                        Address Line 1
                                      </label>
                                    </Form.Item>
                                  </div>
                                  <div className="form-field">
                                    <Form.Item
                                      name="address2"
                                      validateStatus={
                                        formErrors.address2 ? "error" : ""
                                      }
                                      help={formErrors.address2}
                                    >
                                      <Input
                                        type="text"
                                        id="address2"
                                        placeholder=" "
                                        // autoComplete='emailnew'
                                        className="boxShadowFix"
                                        autoComplete="address2"
                                        required
                                        value={formInfo?.address2}
                                        style={{ borderRadius: "0px" }}
                                        onChange={handleChange}
                                        onBlur={(e) => {
                                          if (
                                            e.target.value !== formInfo.address2
                                          ) {
                                            setFormInfo((prev) => ({
                                              ...prev,
                                              address2: e.target.value,
                                            }));
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor="address2"
                                        className="labelTexl"
                                      >
                                        Address Line 2 (Optional)
                                      </label>
                                    </Form.Item>
                                  </div>
                                  <div className="form-field">
                                    <Form.Item
                                      name="city"
                                      validateStatus={
                                        formErrors.city ? "error" : ""
                                      }
                                      help={formErrors.city}
                                      rules={[
                                        {
                                          required: true,
                                          message: "City is required",
                                        },
                                      ]}
                                    >
                                      <Input
                                        type="city"
                                        id="city"
                                        placeholder=" "
                                        // autoComplete='citynew'
                                        className="boxShadowFix"
                                        autoComplete="city"
                                        required
                                        value={formInfo?.city}
                                        style={{ borderRadius: "0px" }}
                                        onChange={handleChange}
                                        onBlur={(e) => {
                                          if (
                                            e.target.value !== formInfo.city
                                          ) {
                                            setFormInfo((prev) => ({
                                              ...prev,
                                              city: e.target.value,
                                            }));
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor="city"
                                        className="labelTexl"
                                      >
                                        City
                                      </label>
                                    </Form.Item>
                                  </div>
                                  {!pre_payment_enabled &&
                                  <>
                                     <div style={{textAlign:"left",fontSize:"18px",
                                                    // fontFamily:"Lato",
                                                    fontWeight:"400",color:"#4A4A4A",marginBottom:"10px"}}>Country/ region</div>
                                  
                                                  <div
                                                            className="form-row"
                                                            style={{
                                                              // maxWidth:"400px",
                                                              padding: "0px",
                                                              margin: "0px",
                                                              display: "flex",
                                                              flexDirection: "column",
                                                              gap: "10px" // spacing between fields
                                                            }}
                                                          >
                                                           
                                                            <Select
                                                              name="country"
                                                              onChange={handleCountryChange}
                                                              className="form-input countryDropdown"
                                                              defaultValue="United Kingdom (UK)"
                                                              bordered={false}
                                                              style={{
                                                                maxWidth:"100%",
                                                                padding: "0 10px",
                                                                border: "0px",
                                                                width: "100%",
                                                                height: "30px",
                                                                textAlign: "left",
                                                                color : "#008385"
                                                              }}
                                                            >
                                                               {countriesName.map((country, index) => (
                                                                  <Option value={country} style={{ color: '#008385' }}>{country}</Option>
                                                              ))}
                                                              
                                                            </Select>
                                                            <Input
                                                              type="text"
                                                              id="postalCode"
                                                              name="postalCode"
                                                              placeholder="Postal code"
                                                              // autoComplete='postalCodenew'
                                                              autoComplete="postal-code"
                                                              value={postalCode}
                                                              style={{
                                                                  height:"30px",
                                                                  maxWidth:"100%",
                                                                  outlineColor:"none",
                                                                  border:"none"
                                                              }}
                                                              onChange={(e) => {
                                                                setPostalCode(e.target.value);
                                                                setPostalCodecheck(e.target.value);
                                                                setCardErrors(prev => ({
                                                                  ...prev,
                                                                  postalCode: validatePostalCode(e.target.value, selectedCountry)
                                                                }));
                                                              }}
                                                              className="form-input postal-code"
                                                            />
                                                          </div>
                                                       
                                  
                                                           {cardErrors.postalCode && (
                                                <div style={{ color: 'red', marginTop: '-10px', marginBottom: '10px', textAlign: 'left',fontSize: '14px' }}>{cardErrors.postalCode}</div>
                                              )}
                                  </>
                                  }
                                         
                                </>
                              )}


  </div>
</div>
           

            
            </div>
            

 <div style={{display:"flex",justifyContent:"center",flexDirection:"column",alignItems:"start"}}>

 { (bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1 || bookingDetails?.oldData?.clinic?.productCategory?.product_category_id == 1) && (

   <span className="appointment-form" style={{textAlign:"left", marginTop:"20px"}}>Reason for the appointment (optional)</span>

 )}
  
<div className="appointment-form">
        { (bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id === 1 || bookingDetails?.oldData?.clinic?.productCategory?.product_category_id == 1)  && (
            <Select
            value={reason}
            onChange={(value) => {setReason(value);}}
            className="custom-select"
            placeholder="Select an option"
            // bordered={false}
            style={{
              border:"1px solid #444",
              textAlign:"left",
              borderRadius:"30px",
              
              padding: '5px',
              width: '100%',
            }}
            >
            {drpoDownData.map((item, index) => (
              <Option value={item?.gp_product_id} key={index}>
                {item.name}
              </Option>
            ))}

            </Select>
        )}


      <textarea
        placeholder="Any further comments?"
        className="custom-textarea"
        value={comments}
        onChange={(e) => setComments(e.target.value)}
        style={{border:"1px solid rgba(74, 74, 74, 1)",resize: 'none',borderRadius:"0px",marginTop: '20px',padding: '5px'}}
        autoComplete="off"
      ></textarea>
      <div  style={{textAlign:"left",  marginBottom:"10px"}}>

          <label className="checkbox-container">
            <div>
              <input
                type="checkbox"
                checked={agreeTnC}
                // onChange={() => setAgreeTnC(!agreeTnC)}
                onChange={() => {
                  setAgreeTnC(!agreeTnC);
                  // Clear error when checkbox is toggled
                  if (formErrors.agreeTnC) {
                    setFormErrors(prev => ({
                      ...prev,
                      agreeTnC: '',
                    }));
                  }
                }}
                autoComplete="off"
                
              />
            </div>

            <div style={{textAlign:"left"}} onClick={() => setAgreeTnC(!agreeTnC)}>
           <span style={{textAlign: 'left'}}>
            I agree with the overall <a href="https://www.londondoctorsclinic.co.uk/terms-conditions/" target="_blank">Terms & Conditions</a> and <a href="https://www.londondoctorsclinic.co.uk/terms-conditions/" target="_blank">Cancellation and Refunds Policy</a>. Information on how we use your data, can be found in our <a href="https://www.londondoctorsclinic.co.uk/terms-conditions/privacy-policy/" target="_blank">Privacy Notice</a>
          </span>
            </div>
          </label>
          {formErrors.agreeTnC && <div style={{ color: 'red',fontSize:"14px",textAlign:"left" }}>{formErrors.agreeTnC}</div>}
      </div>



      <label className="checkbox-container">
        <div>
          <input
            type="checkbox"
            checked={agreeMarketing}
            onChange={() => setAgreeMarketing(!agreeMarketing)}
            autoComplete="off"
            
          />
        </div>

        <div style={{textAlign:"left"}} onClick={() => setAgreeMarketing(!agreeMarketing)}>
        I agree to receive Marketing Communications
        </div>
      </label>
    </div>
            </div>
            </div>
          </div>

{    
 pre_payment_enabled && hasReschedulingCharges && (
    <div className="form-section payment-section">
    <h4 style={{background:"rgba(0, 131, 133, 0.25)" , color:"rgba(0, 131, 133)", padding:"8px ",fontWeight:"400",fontSize:"20px"}} className="textLeft">Payment method:</h4>


<div className="payment-container">

{options.map((option) => (
<label
  key={option.id}
  className={`payment-option ${selected === option.id ? 'selected' : ''}`}
>
  <div style={{ display: 'flex',alignItems: 'center' }}>
  <img src={option.icon} alt={`${option.label} icon`} className="icon" />
  <span>{option.label}</span>
  </div>
  <input
    type="radio"
    name="payment"
    value={option.id}
    style={{height:"20px", width:"20px"}}
    checked={selected === option.id}
    onChange={() => paymentButtonChange(option.id)}
    autoComplete="off"
  />
</label>
))}
</div>
    
{
hasReschedulingCharges && (
<div className="form-section payment-section">

    {formData.paymentMethod === "card" && (
      <>
      {/* <Elements stripe={stripePromise} options={optionsHideLink}> */}
      <Elements stripe={stripePromise}>
        {selected === 'card' && (
          <StripePaymentForm 
          validate={validateForm}
            ref={stripePaymentRef}
            // handlePaymentClick={handlePaymentClick}
            bookingDetails={bookingDetails}
            onSubmit={handlePaymentSuccess}
            selectedPaymentMethod={selected}
            onBack={() => setStep(1)}
            formInfo={formInfo}
            cardholderDifferent={cardholderDifferent}
            setCardholderDifferent={setCardholderDifferent}
            cardholderName={cardholderName}
            setCardholderName={setCardholderName}
            postalCode={postalCode}
            setPostalCode={setPostalCode}
            postalCodeError={postalCodeError}
            setPostalCodeError={setPostalCodeError}
            handleInputChange={handleInputChange}
            onLoadError={handleLoadError}
          />
        )}
        </Elements>
      </>
    )}

      {selected === 'gpay' && clientSecret && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <GooglePayButton 
            publicKey={publicKey}
            validate={validateForm}
            ref={googlePayRef}
            amount={RescheduleAmmount || BookingAmmount}
            onPaymentSuccess={handlePaymentSuccess}
            addLog={addLog}
            clientSecret={clientSecret}
            loading={ClientSecretLoading}
            setLoading={setLoading}
          />
        </Elements>
      )}


      {selected === 'apple' && clientSecret && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <ApplePayButton 
            publicKey={publicKey}
            validate={validateForm}
            ref={applePayRef}
            amount={RescheduleAmmount || BookingAmmount}
            onPaymentSuccess={handlePaymentSuccess}
            addLog={addLog}
            clientSecret={clientSecret}
            loading={ClientSecretLoading}
            setLoading={setLoading}
          />
        </Elements>
      )}


      

</div>
)}
    


    <div className="payment-summary">
      <h4  style={{background:"rgba(0, 131, 133, 0.25)" , color:"rgba(0, 131, 133)", padding:"8px ",fontWeight:"400",fontSize:"20px"}}  className="textLeft"   onClick={handlePaymentDetailsClick}>Payment details:</h4>
      <div style={{margin:"auto",maxWidth:screens.lg?"393px":"93%"}}>
      <div className="summary-row">
        <div className="pament-color"> {hasReschedulingCharges ? "Amount" : "Amount"}</div>
        <div className="pament-color" style={{color:"#4A4A4A"}}>
          {/* { "£ "  (+bookingDetails?.showAppoinmentData?.price || 0 + bookingDetails?.encryptBookingDetails?.rescheduling_charge_details?.amount  || 0)} */}
          £{" "}
          
            {RescheduleAmmount ||  BookingAmmount }

        </div>
      </div>
      <div className="summary-row">
        <div className="pament-color">Payment Method</div>

        <div className="pament-color" style={{color:"#4A4A4A"}}>{formData.paymentMethod === "card" ? "Card" : 
              formData.paymentMethod === "apple" ? "Apple Pay" : "Google Pay"}</div>

      </div>
      <div className="summary-row total">
        <div className="pament-color">Total</div>
        <div className="pament-color" style={{color:"#4A4A4A"}}>
          {/* {  "£ " +  (+bookingDetails?.showAppoinmentData?.price || 0 + +bookingDetails?.encryptBookingDetails?.rescheduling_charge_details?.amount || 0)} */}

          £{" "}
         
      {RescheduleAmmount ||  BookingAmmount }

        </div>

      </div>
      </div>
    </div>
    
    
  </div>
  )}

        </div>
        </form>



            
             
            </>
            
      )}
     
    </div>
    {step ==2 && (<><div className="form-actions" style={{width:"100%",margin:"30px 0px"}}>
              {count ? (
 
<div style={{position:"relative"}}>
        

            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{
                width: "180px",
                height: "40px",
                borderRadius: "10px",
                fontWeight: "500",
                fontSize: "16px",
                marginBottom: "50px",
                backgroundColor: '#008385', // Teal color
                color: '#fff', // White text
              }}
              onClick={async () => {
                setFormSubmitted(true);

                if (!validateForm()) {
                  return;
                }

                if (pre_payment_enabled && hasReschedulingCharges) {
                  if (selected === "gpay") {
                    if (!validateForm()) return;

                    const success = googlePayRef.current?.initiatePayment();
                    if (!success) return;
                  } else if (selected === "apple") {
                    const success = applePayRef.current?.initiatePayment();
                    if (!success) return;
                  } else if (selected === "card") {
                    await stripePaymentRef.current.handleSubmit();
                  } else {
                    await apiCall();
                  }
                } else {
                  await apiCall();
                }
              }}
            >
              {loading
                ? "Processing..."
                : bookingDetails?.showAppoinmentData?.showAppoinmentData?.clinic?.productCategory?.product_category_id == 3 && !pre_payment_enabled ? 'Confirm and book now' : hasReschedulingCharges
                ? "Pay and book now"
                : bookingDetails?.oldDataExist
                ? "Confirm Reschedule"
                : "Confirm Booking"}
            </Button>

              <Button
                        shape="square"
                        icon={<ArrowLeftOutlined style={{ color: '#008385', fontSize: '18px' }} />}
                        style={{
                            backgroundColor: '#C8E6E6', // Light teal
                            border: 'none',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: 0,
                            marginRight: 10,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            position:"absolute",
                            left:"10px",
                            top:"0px"
                        }}
                        onClick={() => {setStep(step-1);setHide(!hide)}}
                    />
                    </div>
              ) : ""}
            </div></>)}
{step === 2 && showLogs && (
      <div>  
        {selected?.toUpperCase()} <br></br>
              {step === 2 && (
          <div className="api-logs-container" style={{
            maxWidth: '800px',
            margin: '20px auto',
            padding: '15px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            maxHeight: '300px',
            overflowY: 'auto',
            border: '1px solid #ddd'
          }}>
            <h4 style={{ marginBottom: '10px' }}>API Logs</h4>
            {apiLogs.length === 0 ? (
              <div>No logs yet. Interactions will appear here.</div>
            ) : (
              <div style={{ fontFamily: 'monospace', fontSize: '14px', textAlign: 'left' }}>
                {apiLogs.map((log, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      marginBottom: '5px',
                      padding: '5px',
                      backgroundColor: log.type === 'error' ? '#ffebee' : 
                                    log.type === 'success' ? '#e8f5e9' : 
                                    log.type === 'warning' ? '#fff8e1' : '#e3f2fd',
                      borderLeft: `4px solid ${
                        log.type === 'error' ? '#f44336' : 
                        log.type === 'success' ? '#4caf50' : 
                        log.type === 'warning' ? '#ffc107' : '#2196f3'
                      }`
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontWeight: 'bold' }}>
                        {new Date(log.timestamp).toLocaleTimeString()}
                      </span>
                      <span style={{ 
                        color: 
                          log.type === 'error' ? '#f44336' : 
                          log.type === 'success' ? '#4caf50' : 
                          log.type === 'warning' ? '#ffc107' : '#2196f3',
                        textTransform: 'capitalize'
                      }}>
                        {log.type}
                      </span>
                    </div>
                    <div style={{ whiteSpace: 'pre-wrap' }}>{log.message}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

       </div>
)}
    </>:<>{contextHolder}
{  !loading &&  <BookingConfirmation 
      getAllHealthScreenData={{ tempData }} 
      showAppoinmentData={dummyProps.showAppoinmentData}  
      hideConfirm={hideConfirm} data={dummyProps.data} 
      BookedAppointmentPayload={BookedAppointmentPayload}
      userData={formInfo}
      paymentIntentResponseCatchPayload={paymentIntentResponseCatchPayload}
    />}</>}
    {showClientSecret && (
      <Elements stripe={stripePromise}>
        <CheckoutForm clientSecret={clientSecretKey} stripe={stripePromise} twoFactAuth={twoFactAuth} twoFactAuthFail={twoFactAuthFail}/>
      </Elements>
      
    )}

    </>
    
  );
};

export default Step4;